import { Cookies } from 'react-cookie';

import { PostDevicesToWarehouseRequest } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const postDevicesToWarehouse = async (requestData: PostDevicesToWarehouseRequest) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.post(
    `devices-by-token/${requestData.token}/give-device-to-site/`,
    { trap_ids: requestData.trap_ids, hub_ids: requestData.hub_ids },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response;
};
